export default {
	// URL: 'https://api-checklist.kepler.com.br/',
	// API_URL: 'https://api-checklist.kepler.com.br/api',
	// OAPI_URL: 'https://api-checklist.kepler.com.br/oapi',
	// URL: 'http://localhost:2500',
	// API_URL: 'http://localhost:2500/api',
	// OAPI_URL: 'http://localhost:2500/oapi',
	URL: 'https://api-hm-kepler.infinitum-ti.com/',
	API_URL: 'https://api-hm-kepler.infinitum-ti.com/api',
	OAPI_URL: 'https://api-hm-kepler.infinitum-ti.com/oapi',
}
